import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { get } from '../../../../../Model/Network/Config/Axios';
import { SearchableSelect } from '../../../../Common/Class/Select/SearchableSelec2';
import { Modal } from '../../../../Common/fModal/Modal';
import {  handleError, showToast } from '../../../../Common/fToast/ToastCallback';
import { LineHeader } from '../../../../Header/LineHeader';
import { useSelector } from 'react-redux';
import { DEV_MODE } from '../../../../../Model/Network/Api/config';
import { FunctionalInput } from '../../../../Common/fInputs';
import { PageLoader } from '../../../../Common/Components/PageLoader';

const TdsLineItem = (props) => {
    const [tds,setTds] = useState([]);
    const [tdsMode,setTdsMode] = useState('percentage');
    const [changeTds,setChangeTds] = useState(false);
    const [allTds,setAllTds] = useState([]);
    const [selectedTds,setSelectedTds] = useState(undefined);
    const Amount = useRef(),CODE=useRef();
    const {onlyGlobalTdsMaster,tdsEntitySegregated,
		tdsAtLineItemAutomationV2,
        tdsAtLineItemAutomation,
		vcTdsMasterVisibility
	} = useSelector((state) => state.auth.config.plugins);
	const TDS_SLAB =useRef()

	const [loader,setLoader] = useState(true);
	const [tdsShown,setTdsShown] = useState(() => {
		if (props.value) {
		  return {
			des: props.value.tdsDesc,
			label: props.value.tdsCode,
			tax: props.value.tdsRate,
		  };
		}
		return undefined;
	});

	let {vendorId,vendor} =props
	let Dev_Mode_Check = (DEV_MODE || window.location.href.includes("localhost")) // dev mode check needs to be removed once it is done from BE on prod

	let fetchAllTds=()=>{
		if (onlyGlobalTdsMaster) {
			const individualHufTypes = vendor && vendor.pan && ["P", "H", "B"].includes(vendor.pan.charAt(3));
			if(vcTdsMasterVisibility){
				get('vendor/config/tds/getAllVcTdsMaster',(e,r)=>{
					if(r && r.tds && r.tds.length){
						let items=[];
						if(props && props.tdsSlabs){
							items=r.tds.filter((item)=>{
								if(item && ("isForeignTds" in item) && !item.isForeignTds){
									return false;
								}
								let flag=0;
								for(let i=0;i<props.tdsSlabs.length;i++){
									if(item.tdsMasterId===props.tdsSlabs[i]){
										flag=1;
										break;
									}
								}
								return flag
							})	
						}
						let arr=items.map(val=>({
							id: val.tdsMasterId,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate:  val.otherRate,
							type:'master'
						}))
						setAllTds(arr)
						setTds(arr)
						setLoader(false);
					}
				})
			}
			else{
				get(`vendor/config/tds/allTdsMaster`, (e, r) => {
					if (r) {
						let items=[];
						if(props && props.tdsSlabs){
							items=r.tds.filter((item)=>{
								if(item && ("isForeignTds" in item) && !item.isForeignTds){
									return false;
								}
								let flag=0;
								for(let i=0;i<props.tdsSlabs.length;i++){
									if(item.id===props.tdsSlabs[i]){
										flag=1;
										break;
									}
								}
								return flag
							})	
						}
						let arr=items.map(val => ({
							id: val.id,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate:  val.otherRate,
							type:'master'
						}))
						setAllTds(arr)
						setTds(arr)
						setLoader(false);
					}
				})
			}
		} else {
			get(`vendor/contacts/${vendorId}/details`,(e1,r1)=>{
				if(r1) {
					get(`/vendor/config/tds/all`,(e,r)=>{
						if (r) {
							if(r1.config.tdsIds.length) {
								let arr=r.tds.filter(item=>_.includes(r1.config.tdsIds,item.id)).map(val=>({
									id: val.id,
									label: val.code,
									des: val.description,
									tax: val.tax
								}))
								setAllTds(arr)
								setTds(arr)
								setLoader(false);
							} else {
								let arr=r.tds.map(val=>({
									id: val.id,
									label: val.code,
									des: val.description,
									tax: val.tax
								}))
								setAllTds(arr)
								setTds(arr)
								setLoader(false);
							}
							
						}
					})
				}
			})
		}
	}
	
    useEffect(()=>{
		if(Dev_Mode_Check && tdsEntitySegregated && props && props.entityId){
			get(`vendor/config/tds/${props.entityId}/allTdsMasterV2`, (e, r) => {
				if (r) {
					if(r.tds && r.tds.length){
						const individualHufTypes = vendor && vendor.pan && ["P", "H", "B"].includes(vendor.pan.charAt(3));		
						let arr=r.tds.map(val => ({
							id: val.id,
							label: val.section,
							des: val.description,
							tax: individualHufTypes ? val.individualHufRate:  val.otherRate
						}))
						setAllTds(arr)
						setTds(arr)
						setLoader(false);
					}
					else{
						fetchAllTds()
					}
				}
				else if(e){
					handleError(e)
				}
			})
		}	
		else{
			fetchAllTds()
		}
    },[])


	useEffect(()=>{
		if(TDS_SLAB && TDS_SLAB.current && selectedTds && !tdsAtLineItemAutomationV2 && !tdsAtLineItemAutomation){
			TDS_SLAB.current.value = selectedTds.tax||0;
		}
	},[selectedTds])

	if(loader){
		return <div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
			<PageLoader />
			<p style={{fontWeight:'bold'}}>TDS Sections are being fetched</p>
		</div>
	}

    return(
        <>      
                <div style={{}}>
                    <p style={{marginBottom:10}} className='floating-top-label' >Tds</p>
                    <div style ={{
                        height:40,
                        background:'var(--off-white)',
                        border:'1px solid var(--border-color)',
                        width:'100%',
                        padding:5,
                        fontSize:12,
                        color:'var(--text-color)'
                    }} onClick={()=>{
						if(props.disabled) return;
                        setChangeTds(true);
                    }}>
                        {(!tdsShown && props.value) ? 
                         `${props.value.tdsCode} (${props.value.tdsAmount})` : tdsShown  ?
                         `${tdsShown.label} (${tdsShown.id})`
                         :
                          null }
                    </div>
                </div>
                {
					changeTds ?
						<Modal
							onSave={() => {
								if (tdsMode === 'percentage') {
									if (!selectedTds) {
										showToast({
											type: 'error',
											value: 'Please enter some value'
										})
										return;
									}
                                    props.onSelect({
                                        "tdsSlab": selectedTds.tax,
                                        "tdsCode": selectedTds.label,
                                        "tdsDesc": selectedTds.des,
										"id": selectedTds.id,
										...(selectedTds && selectedTds.type)?{"type":selectedTds.type}:{}
                                    })
									setTdsShown(selectedTds);
                                    setChangeTds(false);
								} else {
									let amount = Amount.current.value;
									let code = CODE.current.value;
									if (!amount) {
										showToast({
											type: 'error',
											message: "Please enter the amount"
										})
										return;
									}
									if(!code) {
										showToast({
											type: 'error',
											message: "Please enter the remarks"
										})
										return;
									}
                                    setChangeTds(false);
									showToast({
										type: 'success',
										message: "Field update successfully"
									})
								}
							}}
							style={{
								save: {
									padding: '12px 15px',
									width: '100%',
									textAlign: 'center',

								}
							}}
							show={true}
							title="Select Tds"
							des="Select Tds"
							close={() => {
                                setChangeTds(false);
							}}
							buttonName="Select Tds"
						>
							<LineHeader
								items={
									[
										{
											name: 'Select Percentage', 
											active: tdsMode === 'percentage',
											click: () => {
                                                setTdsMode('percentage');
											}
										},

									]
								}
							/>
							<div style={{
								marginTop: 20
							}}/>
							{
								tdsMode === 'percentage' ?
									<SearchableSelect
										reset={()=>{setTds(allTds)}}
										disabled={props.disabled}
										label="Select Tds"
										placeholder="Select Tds"
										onChange={val => {
											if (val.length > 0) {
												let allItems = allTds.filter(item => {
													if (item.label.toLowerCase().includes(val.toLowerCase())) {
														return true
													}
													if (item.des.toLowerCase().includes(val.toLowerCase())) {
														return true;
													}
													if (String(item.tax).toLowerCase().includes(val.toLowerCase())) {
														return true
													}
													return false;
												})

                                                setTds(allItems);
											} else {
                                                setTds(allTds);
											}
										}}
										select={selectedTds => {
                                            setSelectedTds(selectedTds);
										}}
										value={selectedTds}
										items={tds}
									/>
									: 
									null

							}
						  {selectedTds && !tdsAtLineItemAutomationV2 && !tdsAtLineItemAutomation &&
							<FunctionalInput
								ref={TDS_SLAB}
								title="Tds Slab"
								type="number"
								onChange={(e) => {
									setSelectedTds({...selectedTds,tax:Number(e.target.value)})
								}}
							/>
						}
						</Modal>
						: null
				}

        </>
    )
}

export default TdsLineItem;